// extracted by mini-css-extract-plugin
export default {"componentWrapper":"PeriodicList_componentWrapper__5gO9c"};